import React from "react";
import PropTypes from "prop-types";
import StructuralVariant from "../../../../../../models/StructuralVariant";

function ExacCNV({ item }) {
  const { exac_population: population, quality } = item.data;

  return (
    <div className="tw-px-1 tw-py-px">
      <div>
        {population ? (
          <div className="tooltip-row">
            <div className="tooltip-label tw-w-20">Population</div>
            <div className="tw-w-2" />
            <div className="tw-flex-grow">{population}</div>
          </div>
        ) : null}
        {quality ? (
          <div className="tooltip-row">
            <div className="tooltip-label tw-w-20">Quality</div>
            <div className="tw-w-2" />
            <div className="tw-flex-grow">{quality}</div>
          </div>
        ) : null}
      </div>
    </div>
  );
}

ExacCNV.propTypes = {
  item: PropTypes.instanceOf(StructuralVariant).isRequired,
};

ExacCNV.defaultProps = {};

export default ExacCNV;
